module.exports = __webpack_public_path__ + "static/media/scorbit-vision-3up-leaderboard.cb41dd52.png";